
export class LimitedEditionData {

	constructor(public id: string, public quantityAvailable: number, public quantityTotal: number) { }

}
